import MuiAlert from '@mui/material/Alert';
import React from 'react';

export const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={2} ref={ref} variant="filled" {...props} />;
});